(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["td-shipping-protection-bootstrap"] && !Shopify.designMode) return;
  try {
    const shippingProtectionElement = document.querySelector(
    '[data-td-shipping-protection-script-url]'
  );
  const shippingProtectionScriptUrl =
    shippingProtectionElement?.dataset.tdShippingProtectionScriptUrl;

  if (
    window.customElements &&
    !customElements.get('td-shipping-protection') &&
    shippingProtectionScriptUrl
  ) {
    import(shippingProtectionScriptUrl).catch(function(error) {
      console.warn(
        'TdShippingProtection: failed to load script',
        error
      );
    });
  }
  } catch(e) { console.error(e); }
})();

})();
